import { Auth } from 'aws-amplify';
import { AuthToken } from './types';

/**
 * Returns the user's auth tokens (access and refresh).
 * This is only for use in contexts where hooks are not available, otherwise prefer `useAuthToken`.
 */
export const getAuthToken = async (): Promise<AuthToken | undefined> => {
  const session = await Auth.currentSession();
  if (!session) return undefined;
  const access = session.getAccessToken();
  return {
    access: {
      token: access.getJwtToken(),
      expiresAt: access.getExpiration() * 1000,
      issuedAt: access.getIssuedAt() * 1000,
    },
    refresh: { token: session.getRefreshToken().getToken() },
  };
};

export async function requireAuthToken() {
  const token = (await Auth.currentSession())?.getAccessToken()?.getJwtToken();
  if (!token) {
    throw new Error('Unable to access current sessions JWT.');
  }

  return token;
}

export async function requireAuthHeaders() {
  const token = await requireAuthToken();
  return {
    Authorization: `Bearer ${token}`,
  };
}
